module.exports = __webpack_public_path__ + "img/star_selected.3d0bf680.png";